<script setup lang="ts">
import { LucideMapPin } from 'lucide-vue-next'

const route = useRoute()

const props = defineProps<{
  link?: string
}>()
</script>
<template>
  <div class="relative overflow-hidden rounded-lg border px-4 py-6">
    <div
      class="absolute inset-0 z-0 bg-cover bg-center blur-sm"
      style="background-image: url('/images/photostock/block-map.avif')"
    />

    <div class="relative z-10 flex flex-col items-center space-y-5 text-center">
      <div>
        <Heading tag="h2" class="h5 font-serif leading-5">{{
          $t('widget.bank_page.show_on_map.heading')
        }}</Heading>
        <p class="text-xs text-gray-700">{{ $t('widget.bank_page.show_on_map.description') }}</p>
      </div>

      <Button as-child>
        <NuxtLinkLocale :to="props.link ? props.link : `${route.path}/branches`">
          <LucideMapPin class="h-5 w-5" />
          {{ $t('widget.bank_page.show_on_map.show_on_map') }}
        </NuxtLinkLocale>
      </Button>
    </div>
  </div>
</template>
